import palette from '../../theme/palette';

const theme = {
  slateViewCounter: {
    background: palette.defaultText,
    color: palette.white,
  },
  slateViewCounterFiltered: {
    background: palette.brandOrange,
    color: palette.white,
  },
  slateViewActionStyle: {
    minWidth: 40,
    height: 36,
  },
  slateViewActionButtonSettings: {
    borderTopRightRadius: 0,
    borderBottomRightRadius: 0,
  },
  slateViewActionButtonExport: {
    borderTopLeftRadius: 0,
    borderBottomLeftRadius: 0,
  },
  slateViewBorderRadius: {
    borderTopRightRadius: 4,
    borderBottomRightRadius: 4,
  },
  selectorButton: {
    height: 36,
    whiteSpace: 'nowrap',
    borderRadius: 8,
    boxShadow: '0 2px 8px rgba(23, 42, 64, 0.3), 0 1px 3px rgba(0, 0, 0, 0.15)',
  },
  selectorButtonVariantList: {
    alignItems: 'center',
    whiteSpace: 'nowrap',
    width: '100%',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    backgroundColor: palette.sidebarBgHover,
    borderRadius: 8,
  },
  selectorButtonVariantMap: {
    backgroundColor: palette.sidebarBgHover,
    borderRadius: 8,
  },
  slateViewCreateButton: {
    backgroundColor: palette.primary,
  },
  selectorButtonLabel: {
    textTransform: 'none',
    fontSize: 14,
    fontWeight: 500,
    color: palette.sidebarTextHover,
    letterSpacing: '0.01em',
  },
  selectorButtonIcon: {
    color: palette.sidebarTextHover,
    fontSize: 22,
    position: 'absolute',
    right: -4,
    top: 7,
  },
  fakeSlateViewSelector: {
    height: 34,
    borderRadius: 4,
    backgroundColor: 'rgb(3, 191, 152)',
    fontSize: 16,
    padding: '0px 16px',
    color: 'rgb(255, 255, 255)',
    display: 'flex',
    maxWidth: 300,
    alignItems: 'center',
    whiteSpace: 'nowrap',
    width: '100%',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    flexDirection: 'row',
  },
  popoverStyle: {
    transition:
      'transform 350ms cubic-bezier(0.23, 1, 0.32, 1) 0ms, opacity 350ms cubic-bezier(0.23, 1, 0.32, 1) 0ms',
  },
  autoCompleteSearch: {
    textField: {
      textIndent: 25,
    },
    underline: {
      bottom: 1,
      borderColor: palette.grey200,
    },
    input: {
      width: `calc(100% - 50px)`,
    },
  },
  listIcon: {
    top: 2,
    color: palette.success,
    fontSize: 20,
  },
  mapIcon: {
    top: 2,
    left: 8,
    color: palette.brandOrange,
    fontSize: 20,
  },
  menuItemInnerStyle: {
    padding: '0px 16px 0px 46px',
  },
  counterList: {
    backgroundColor: palette.success,
  },
  counterMap: {
    backgroundColor: palette.brandOrange,
  },
  labelForSelector: {
    alignItems: 'center',
    whiteSpace: 'nowrap',
    width: 'calc(100% - 25px)',
    maxWidth: 'calc(100% - 25px)',
    marginRight: 25,
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    display: 'block',
  },
  slateViewActionIconStyle: {
    color: palette.cardTitle
  }
};

export default theme;
